import { bl_applet_label_list_ext_RowInterface, bl_applet_label_list_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class AppletLabelListContainerModel extends BaseContainerModel {
    bl_applet_label_list_hdr: bl_applet_label_list_hdr_RowClass = new bl_applet_label_list_hdr_RowClass();
    bl_applet_label_list_exts: Array<bl_applet_label_list_ext_RowInterface> = [];
}
